import apiInst from '../api.js';
import ProductRegistration from './productRegistration.js';
import axios from 'axios';
import { i18n } from '../../i18n.js';
axios.defaults.headers.common['X-Source-App'] = 'OrderPortal';

// I5618: timeout of a real (not validate-only) import call, in milliseconds. Classify and dry runs
// keep the 60 s of the api instance; the backend allows a packaging import up to 90 s.
export const IMPORT_TIMEOUT = 150000;

class ProductService {
  constructor() {
    console.log('Product service inst');
  }

  getBrands() {
    const GLN = JSON.parse(localStorage.getItem('client')).informationProvider;
    return apiInst.get(`/product/brands/${GLN}`);
  }



  getMarkets() {
    return apiInst.get('/product/markets');
  }

  getRetailers() {
    return apiInst.get(`/product/retailers`);
  }

  productEdit(transactionId, product){
    console.log('productInformation', product)
    const GLN = JSON.parse(localStorage.getItem('client')).informationProvider;
    const payload = {
      metaData: {
        userId: 100234,
        informationProvider: GLN
      },
      productInformation: {
        "basicInformation": {
          "productArticleNumber": product.productInformation.productArticleNumber,
          "productBrandName": product.productInformation.productBrandName,
          "productName": product.productInformation.productName,
          "productStartDate": this.formatDate(product.productInformation.productStartDate),
          "productTargetMarkets": product.productInformation.productTargetMarkets.map((item) => item.code),
      },
      "extendedInformation": product.productInformation.extendedInformation,
      },
      productPackagingHierarchy: product.productPackagingHierarchy,
    };
    console.log('productInformation', payload)
    return apiInst.post(`/product/update/${transactionId}`, payload);
  }

  formatDate(date) {
    if (!date) return null;

    const [day, month, year] = date.split('-');
    return `${year}-${month}-${day}`;
  }

  productRegistration(productList) {
    let mappedList = ProductRegistration.mapping(productList);
    const GLN = JSON.parse(localStorage.getItem('client')).informationProvider;

    return apiInst.post('/product/register', {
      metaData: {
        userId: 100234,
        informationProvider: GLN
      },
      productList: [...mappedList]
    });
  }

  async getIncompleteRegistration() {
    const GLN = JSON.parse(localStorage.getItem('client')).informationProvider;
    try {
      const res = await apiInst.get(`/product/incompleteRegistration/${GLN}`);
      console.log('GET INCOMPLETE REGISTRATION', res.data.data)
      return ProductRegistration.parseDashboardData(res.data.data);
    } catch (e) {
      console.log('GET INCOMPLETE REGISTRATION', e);
    }
  }

  async getIncompleteMarketing() {
    const GLN = JSON.parse(localStorage.getItem('client')).informationProvider;
    try {
      const res = await apiInst.get(`/product/incompleteMarketing/${GLN}`);
      return ProductRegistration.parseMarketingData(res.data.data);
    } catch (e) {
      console.log('GET INCOMPLETE MARKETING', e);
    }
  }


  getPackagingType(pkgType) {
    try {
      return apiInst.get(`/product/${pkgType}`);
    } catch (e) {
      return e;
    }
  }

  saveLogisticsInfo(payload) {
    const { id, logisticsInformation, productBrandName, productName } = payload;
    const GLN = JSON.parse(localStorage.getItem('client')).informationProvider;
    let replacedLogisticsInformation = JSON.parse(
      JSON.stringify(logisticsInformation, (key, value) => (value === '' ? null : value))
    );
    return apiInst.post('/product/logistics', {
      _id: id,
      metaData: {
        userId: 100234,
        informationProvider: GLN,
        productBrandName,
        productName,
        logisticsComplete: false
      },
      logisticsInformation: replacedLogisticsInformation
    });
  }

  finalizeLogistics(payload) {
    const { id, productBrandName, productName } = payload;
    const GLN = JSON.parse(localStorage.getItem('client')).informationProvider;

    return apiInst.post('/product/logistics/finalize', {
      _id: id,
      metaData: {
        userId: 100234,
        informationProvider: GLN,
        productBrandName,
        productName,
        logisticsComplete: true
      }
    });
  }

  validateLogistics(payload) {
    const { id, productBrandName, productName } = payload;
    const GLN = JSON.parse(localStorage.getItem('client')).informationProvider;

    return apiInst.post('/product/logistics/complete', {
      _id: id,
      metaData: {
        userId: 100234,
        informationProvider: GLN,
        productBrandName,
        productName,
        logisticsComplete: true
      }
    });
  }

  finalizeTradeitem(transactionId) {
    const GLN = JSON.parse(localStorage.getItem('client')).informationProvider;

    return apiInst.post(`/product/finalize/${transactionId}`, {
      metaData: {
        userId: 100234,
        informationProvider: GLN,
      }
    });
  }

  deleteTradeitem(transactionId) {
    const GLN = JSON.parse(localStorage.getItem('client')).informationProvider;

    return apiInst.delete(`/product/remove/${transactionId}`, {
      data: {
        metaData: {
          userId: 100234,
          informationProvider: GLN,
        }
      }
    });
  }

  submitPublication(payload) {
    const { id, variantIndex, informationProviders } = payload;

    return apiInst.post('/product/publication', {
      _id: id,
      variantIndex,
      informationProviders
    });
  }

  submitBatchPublication(payload) {
    return apiInst.post('/product/publication/batched', {
      batchedPublication: payload
    });
  }

  storePublicationBatched(payload) {

    return apiInst.post('/product/publication/batched/store', {
      batchedPublication: payload
    });
  }

  downloadTemplate() {
    const lang = i18n.locale || 'nl';
    return apiInst.get(`/template/product/xxtract?lang=${lang}`);
  }
  downloadPackagingTemplate() {
    return apiInst.get('/template/packaging');
  }
  downloadMarketingTemplate() {
    return apiInst.get('/template/marketing');
  }

  // I5618: the metaData every call of the single upload screen shares. `options.gln` is the GLN
  // the page captured when it opened; only without it is localStorage read. The flags are sent
  // only for an explicit true, so an absent or odd value is a normal import.
  uploadMetaData(name, options = {}) {
    const GLN = options.gln || JSON.parse(localStorage.getItem('client')).informationProvider;
    const metaData = {
      userId: 100234,
      informationProvider: GLN,
      filename: name,
      userLang: i18n.locale
    };
    if (options.validateOnly === true) {
      metaData.validateOnly = true;
    }
    if (options.holdForConcept === true) {
      metaData.holdForConcept = true;
    }
    if (typeof options.batchId === 'string' && options.batchId) {
      metaData.batchId = options.batchId;
    }
    if (Array.isArray(options.batchGtins)) {
      metaData.batchGtins = options.batchGtins;
    }
    return metaData;
  }

  // I5618: a real import may take longer than a check, so it waits IMPORT_TIMEOUT before the screen
  // reports "unknown"; a validate-only call keeps the default.
  uploadRequestConfig(options = {}) {
    return options.validateOnly === true ? {} : { timeout: IMPORT_TIMEOUT };
  }

  // I5618: what kind of file is this? 200 → {type, format}; 422 → {message, expectedTemplates}.
  // Stores nothing.
  classifyFile(payload, name, options = {}) {
    const GLN = options.gln || JSON.parse(localStorage.getItem('client')).informationProvider;
    return apiInst.post('/import/classify', {
      metaData: {
        userId: 100234,
        informationProvider: GLN,
        filename: name,
        userLang: i18n.locale
      },
      content: payload
    });
  }

  // I5618: the aanmeldformulier, through the unified endpoint that recognises the format itself
  // (standard, Superunie, Hessing), so the screen never chooses a flow by file name.
  importSpreadsheet(payload, name, options = {}) {
    const metaData = this.uploadMetaData(name, options);
    metaData.services = options.services;
    metaData.urgent = options.urgent;
    return apiInst.post('/product/import-spreadsheet', { metaData, content: payload }, this.uploadRequestConfig(options));
  }

  // I5598: twee stappen. { validateOnly: true } laat de backend alleen controleren (niets
  // opgeslagen, niets naar GS1); { gln } legt de GLN vast die de gebruiker in het scherm zag, in
  // plaats van een verse lezing van localStorage. I5618: plus holdForConcept, batchId, batchGtins.
  uploadPackagingFile(payload, name, options = {}) {
    const metaData = this.uploadMetaData(name, options);
    return apiInst.post('/import/packaging', { metaData, content: payload }, this.uploadRequestConfig(options));
  }

  uploadMarketingFile(payload, name, options = {}) {
    const metaData = this.uploadMetaData(name, options);
    return apiInst.post('/import/marketing', { metaData, content: payload }, this.uploadRequestConfig(options));
  }

  batchRemove(productIds) {
    const GLN = JSON.parse(localStorage.getItem('client')).informationProvider;
    return apiInst.delete('/product/batch-remove', {
      data: {
        userId: 100234,
        informationProvider: GLN, 
        documentIds: productIds
      }
    });
  }

  async getHistory() {
    const GLN = JSON.parse(localStorage.getItem('client')).informationProvider;
    try {
      const res = await apiInst.get(`/product/completedRegistration/${GLN}`);
      console.log('GET COMPLETE REGISTRATION - HISTORY', res.data.data)
      return ProductRegistration.parseHistoryData(res.data.data);
    } catch (e) {
      console.log('GET COMPLETE REGISTRATION - HISTORY', e);
    }
  }

  submitMarketingInfo(payload) {
    const uniqueSellingPoints = [];
    const description = [];
    const keywords = [];
    //TODO the language in future will be dynamic
    const language = 'nl';
    const { id, uspList, productDescription, keywordsList } = { ...payload };

    if (uspList && uspList.length) {
      let uspContent = uspList.map((item) => item.info);
      uspContent = uspContent.length == 1 && uspContent[0] == null ? null : uspContent;

      if (uspContent) {
        uniqueSellingPoints.push({ language, content: uspContent });
      }
    }

    if (productDescription.length) {
      description.push({ language, content: productDescription });
    }

    if (keywordsList.length) {
      keywords.push({ language, content: keywordsList.join(',') });
    }

    return apiInst.post('/product/marketing', {
      _id: id,
      marketingInformation: {
        uniqueSellingPoints,
        description,
        keywords
      }
    });
  }

  finalizeMarketing(_id) {
    return apiInst.post('/product/marketing/finalize', { _id });
  }

  uploadLabelFiles(hierarchyKeys, files) {
    const formData = new FormData();

    formData.append('hierarchyKeys', JSON.stringify(hierarchyKeys)); // Convert hierarchyKeys to JSON string
    for (let i = 0; i < files.length; i++) {
      formData.append('files', files[i]);
    }

    return axios.post(process.env.VUE_APP_MEDIA_URL + '/customers-label', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  }
  changeLabelStatus(id, labelFilesCount) {
    return apiInst.patch(`/product/status/label`, {
      documentId: id,
      newStatus: 'received',
      labelFilesCount
    });
  }

  changeShipmentStatus(id, status){
    return apiInst.patch(`/product/status/shipment`, { 
      "documentId": id,
      "newStatus": status
     });
  }

  async addServices(products, services) {
    return await apiInst.patch('/product/services/update', {
      selectedProducts: products,
      ...services
    });
  }
}

export default new ProductService();
